import '../../../js/core.js';
import '../../../js/contact-form.js';
import modalResponseRender from "../../../js/modals/components/modalResponseRender";
import './page-contact-us.less';


function responseModal(respMessage, contactFormSelector){
    let contactModalWrapper = $('#contactUsFormWrapper');
    let dataAttributesList = contactModalWrapper.data();

    let contactFormContainer = document.querySelector(`${contactFormSelector}`);
    let formSelector = contactFormContainer.querySelector('form'); 
    formSelector.reset();

    let $contactForm = $(`${contactFormSelector} form`);
    $contactForm.find('.not-empty').removeClass('not-empty');
    $contactForm.find('.focus').removeClass('focus');
    
    modalResponseRender(respMessage, dataAttributesList); 
}

function contactUsForms( contactFormSelector ){
    let contactFormContainer = document.querySelector(`${contactFormSelector}`);
    let contactForm = contactFormContainer.querySelector('.wpcf7');
    let eventLabel = $('#contactUsFormWrapper').data('event');

    $.get("https://ipinfo.io", function(response) {
        $(`${contactFormSelector} .wpcf7`).find('[name=user-ip]')
            .val(response.ip);
    }, "jsonp");

    if( document.cookie.indexOf('eos_user_id=') >= 0) {
        $.ajax({
            type: 'GET',
            xhrFields: {withCredentials: true},
            url: 'https://auth.eos.com/account/details/',
            success: function (response) {
                let first_name = $(contactFormSelector).find('[name=first-name]');
                let last_name = $(contactFormSelector).find('[name=last-name]');
                let email = $(contactFormSelector).find('[name=user-email]');

                if (response.first_name) {
                    first_name.val(response.first_name).parent().parent('.form-field').addClass('not-empty');
                }

                if (response.last_name) {
                    last_name.val(response.last_name).parent().parent('.form-field').addClass('not-empty');
                }

                if (response.email) {
                    email.val(response.email).parent().parent('.form-field').addClass('not-empty');
                }
            },
        })
    }


    contactForm.addEventListener('submit', ()=>{
        dataLayer.push({
            'event':'EOSCOM',
            'eventCategory':'EosComEvents',
            'eventAction':'contact_from_submit',
            'eventLabel': 'first_section',
            'eventContent': '',
            'eventPosition': '',
            'eventContext': '',
        });
        $(contactForm).find( ".rd-btn_spinner" ).addClass("loading-start").attr("disabled",true);
    });


    contactForm.addEventListener( 'wpcf7invalid', function( event ) {
            let arr = [];
            let eventContent = [];
            event.detail.apiResponse.invalid_fields.map(item=>arr.push(item.field));
            const getValue = (key) => event.detail.inputs.find(el => el.name == key) ? event.detail.inputs.find(el => el.name == key).value : '';
            for(let i = 0; i < arr.length; i++) eventContent.push(`${arr[i]} - ${getValue(arr[i])}`);
            dataLayer.push({
                'event':'EOSCOM',
                'eventCategory':'EosComEvents',
                'eventAction':'contact_form_error',
                'eventLabel': 'first_section',
                'eventContent': '',
                'eventPosition': '',
                'eventContext': '',
            });
            dataLayer.push({
                'event':'EOSCOM',
                'eventCategory':'EosComEvents',
                'eventAction':'Contact Form Error',
                'eventLabel': eventLabel,
                'eventContent': eventContent.join(', ')
            });

            $(contactForm).find( ".rd-btn_spinner" ).removeClass("loading-start").removeAttr("disabled");
        }, false );

    contactForm.addEventListener( 'wpcf7mailsent', function( event ) {
            (function($){
                responseModal(event, contactFormSelector);
                
                dataLayer.push({
                    'event':'EOSCOM',
                    'eventCategory':'EosComEvents',
                    'eventAction':'contact_form_success',
                    'eventLabel': 'first_section',
                    'eventContent': '',
                    'eventPosition': '',
                    'eventContext': '',
                });
                dataLayer.push({
                    'event':'EOSCOM',
                    'eventCategory':'EosComEvents',
                    'eventAction':'Contact Form Success Submit',
                    'eventLabel': eventLabel,
                });

                $(contactForm).find( ".rd-btn_spinner" ).removeClass("loading-start").removeAttr("disabled");
            })($);
        }, false );

    contactForm.addEventListener( 'wpcf7mailfailed', function( event ) {
            (function($){
                responseModal(event, contactFormSelector);
                
                $(contactForm).find( ".rd-btn_spinner" ).removeClass("loading-start").removeAttr("disabled");
                dataLayer.push({
                    'event':'EOSCOM',
                    'eventCategory':'EosComEvents',
                    'eventAction':'contact_form_error',
                    'eventLabel': 'first_section',
                    'eventContent': '',
                    'eventPosition': '',
                    'eventContext': '',
                });
                dataLayer.push({
                    'event':'EOSCOM',
                    'eventCategory':'EosComEvents',
                    'eventAction':'Contact Form Error',
                    'eventLabel': eventLabel,
                });

            })($);
        }, false );

    contactForm.addEventListener( 'wpcf7spam', function( event ) {
            (function($){
                responseModal(event, contactFormSelector);
                
                $(contactForm).find( ".rd-btn_spinner" ).removeClass("loading-start").removeAttr("disabled");
                dataLayer.push({
                    'event':'EOSCOM',
                    'eventCategory':'EosComEvents',
                    'eventAction':'contact_form_error',
                    'eventLabel': 'first_section',
                    'eventContent': '',
                    'eventPosition': '',
                    'eventContext': '',
                });
                dataLayer.push({
                    'event':'EOSCOM',
                    'eventCategory':'EosComEvents',
                    'eventAction':'Contact Form Error',
                    'eventLabel': eventLabel,
                });

            })($);
        }, false );
}
   

(function(){
    contactUsForms('.form-content-contact-us');
})();